import {
  Typography,
} from "@mui/material";
import { useEffect, useState } from "react";
import { ResponsiveRow } from "../../../../constants/layout.constants";
import ModalContainerModule from "../../../modules/modalContainer";
import {
  formatCurrency,
  isEmptyObject,
  isNullUndefined,
  sortAlphaNum,
} from "../../../../util/util";
import { DetailsColumn, DetailsContainer, DetailsLabel, DetailsRow, DetailsText } from "../../../../constants/component.constants";
import MuiDataGrid from "../../../modules/MuiDataGrid";

/**
 *
 * REQUIRED PROPS
 *
 * handleSaveChanges
 * setEditUnitModal
 * editUnitModal
 * unit
 *
 */

export default function ViewCourtModal(props) {
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState("");
  const [bankName, setBankName] = useState("");
  const [description, setDescription] = useState("");
  const [mpesaPaybill, setMpesaPaybill] = useState("");
  const [useBankAccount, setUseBankAccount] = useState(false);
  const [useMpesa, setUseMpesa] = useState(false);
  const [hideBalanceBroughtForward, setHideBalanceBroughtForward] = useState(false);
    const [hideOutstandingAmount, setHideOutstandingAmount] = useState(false);
  const [units, setUnits] = useState([]);

  useEffect(() => {
    if (!isEmptyObject(props.court)) {
      setName(props.court.name);
      setBankName(props.court.bankName);
      setDescription(props.court.description);
      if(!isNullUndefined(props.court.courtPayInfo) && !isEmptyObject(props.court.courtPayInfo)) {
        setMpesaPaybill(props.court.courtPayInfo.mpesaPaybill)
        setUseMpesa(props.court.courtPayInfo.useMpesa)
        setUseBankAccount(props.court.courtPayInfo.useBankAccount)
        setHideBalanceBroughtForward(props.court.courtPayInfo.hideBalanceBroughtForward)
        setHideOutstandingAmount(props.court.courtPayInfo.hideOutstandingAmount)
      }
      setUnits(props.court.courtUnits)
    }
    setLoading(false);
  }, [props.court]);

  const unitColumns = [
    {
      field: "name",
      headerName: "Name",
      minWidth: 230,
      flex: 2.3,
      sortComparator: sortAlphaNum,
    },
    {
      field: "type",
      headerName: "Type",
      minWidth: 300,
      flex: 3,
      valueGetter: (params) => params.value?.name,
      type: "string",
    },
    {
      field: "status",
      headerName: "Status",
      minWidth: 150,
      flex: 1.5,
      valueGetter: (params) => params.value?.name === "Available" ? "Vacant" : params.value?.name,
      type: "string",
    },
    {
      field: "sqft",
      headerName: "Square Meters",
      minWidth: 115,
      flex: 1.15,
      valueFormatter: (params) => formatCurrency(params.value),
      type: "number",
    },
    {
      field: "rent",
      headerName: "Rent",
      minWidth: 130,
      flex: 1.3,
      valueFormatter: (params) => formatCurrency(params.value),
      type: "number",
    },
    {
      field: "rentPerSqft",
      headerName: "Rent /SqM",
      minWidth: 115,
      flex: 1.15,
      valueFormatter: (params) => formatCurrency(params.value),
      type: "number",
    },
    {
      field: "beds",
      headerName: "Beds",
      minWidth: 100,
      flex: 1,
      type: "number",
    },
    {
      field: "baths",
      headerName: "Baths",
      minWidth: 100,
      flex: 1,
      type: "number",
    }
  ];

  return (
    <ModalContainerModule
      size="specialEditPropertyUnit"
      cancel={() => props.cancel()}
      openModal={props.viewOpen}
      modalTitle={"View Court"}
    >
      <ResponsiveRow
        sx={{ width: "100%", height: "auto", alignItems: "center" }}
      >
        <DetailsContainer sx={{width: "100%"}}>
          <DetailsColumn sx={{width: "50%"}}>
            <DetailsRow>
              <DetailsLabel>Name: </DetailsLabel>
              <DetailsText>{name}</DetailsText>
            </DetailsRow>
            <DetailsRow>
              <DetailsLabel>Description: </DetailsLabel>
              <DetailsText>{description}</DetailsText>
            </DetailsRow>
          </DetailsColumn>
          <DetailsColumn sx={{width: "50%"}}>
            {useMpesa && (
              <>
                <DetailsRow>
                  <DetailsLabel>Mpesa Paybill: </DetailsLabel>
                  <DetailsText>{mpesaPaybill}</DetailsText>
                </DetailsRow>
              </>
            )}
            {useBankAccount && (
              <>
                <DetailsRow>
                  <DetailsLabel>Bank Account: </DetailsLabel>
                  <DetailsText>{bankName}</DetailsText>
                </DetailsRow>
              </>
            )}
            <DetailsRow>
              <DetailsLabel>Hiding Balance Brought Forward: </DetailsLabel>
              <DetailsText>{hideBalanceBroughtForward ? "Yes" : "No"}</DetailsText>
            </DetailsRow>
            <DetailsRow>
                          <DetailsLabel>Hiding Receipt Outstanding Amount: </DetailsLabel>
                          <DetailsText>{hideOutstandingAmount ? "Yes" : "No"}</DetailsText>
                        </DetailsRow>
          </DetailsColumn>
        </DetailsContainer>
        {units.length > 0 && (
          <ResponsiveRow sx={{width: "100%"}}>
            <Typography variant="h3" sx={{width: "100%", marginBottom: "10px"}}>COURT UNITS</Typography>
            <MuiDataGrid
              dataGridColumns={unitColumns}
              dataGridRows={units}
              serverPagination={false}
              noSelection={true}
              noBoxShadow={true}
              loading={loading}
              totalRows={units.length}
              sx={{maxHeight: "60vh"}}
            />
          </ResponsiveRow>
        )}
      </ResponsiveRow>
    </ModalContainerModule>
  );
}
